/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanBarcodeDatamatrixIcon16Light } from './ScanBarcodeDatamatrixIcon16Light';
import { ScanBarcodeDatamatrixIcon16Regular } from './ScanBarcodeDatamatrixIcon16Regular';
import { ScanBarcodeDatamatrixIcon16Solid } from './ScanBarcodeDatamatrixIcon16Solid';
import { ScanBarcodeDatamatrixIcon20Light } from './ScanBarcodeDatamatrixIcon20Light';
import { ScanBarcodeDatamatrixIcon20Regular } from './ScanBarcodeDatamatrixIcon20Regular';
import { ScanBarcodeDatamatrixIcon20Solid } from './ScanBarcodeDatamatrixIcon20Solid';
import { ScanBarcodeDatamatrixIcon24Regular } from './ScanBarcodeDatamatrixIcon24Regular';
import { ScanBarcodeDatamatrixIcon24Solid } from './ScanBarcodeDatamatrixIcon24Solid';
import { ScanBarcodeDatamatrixIcon32Regular } from './ScanBarcodeDatamatrixIcon32Regular';
import { ScanBarcodeDatamatrixIcon64Regular } from './ScanBarcodeDatamatrixIcon64Regular';
var sizes = {
    16: {
        light: ScanBarcodeDatamatrixIcon16Light,
        regular: ScanBarcodeDatamatrixIcon16Regular,
        solid: ScanBarcodeDatamatrixIcon16Solid,
    },
    20: {
        light: ScanBarcodeDatamatrixIcon20Light,
        regular: ScanBarcodeDatamatrixIcon20Regular,
        solid: ScanBarcodeDatamatrixIcon20Solid,
    },
    24: {
        regular: ScanBarcodeDatamatrixIcon24Regular,
        solid: ScanBarcodeDatamatrixIcon24Solid,
    },
    32: {
        regular: ScanBarcodeDatamatrixIcon32Regular,
    },
    64: {
        regular: ScanBarcodeDatamatrixIcon64Regular,
    },
};
export var ScanBarcodeDatamatrixIcon = forwardRef('ScanBarcodeDatamatrixIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
